import { render, staticRenderFns } from "./OnlineOrders.vue?vue&type=template&id=1a3fde6c&scoped=true&"
import script from "./OnlineOrders.vue?vue&type=script&lang=js&"
export * from "./OnlineOrders.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOrders.vue?vue&type=style&index=0&id=1a3fde6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3fde6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSelect,VToolbar})
